import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createDoneCallHistorySlice = (set, get) => ({
    crmDoneCallHistory: {
        loading: false,
        data: [],
    },
    getCrmDoneCallHistory: async (ID) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmDoneCallHistory: { ...state.crmDoneCallHistory, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/done-call-history/${ID}`,
                headers: { token }
            });
            set(state => ({ crmDoneCallHistory: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmDoneCallHistory: { ...state.crmDoneCallHistory, loading: false } }));
        }
    }
});
